export default "__VITE_ASSET__CujsahUJ__"